export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=707ded95ef63c7644f8dd58bb7af560da97e2e2d67&name=pushAdClickData!'